import React from "react";
import { Card, Row, Col, Progress, Button, Flex, Typography, notification } from "antd";
import { CalendarOutlined, UserOutlined, DollarOutlined, FileOutlined, ExceptionOutlined, AuditOutlined } from "@ant-design/icons";
import ComponentModal from "./PayrollComponents/ComponentModal";
import ReviewEmployees from "./ReviewEmployees";
import { useSelector } from "react-redux";
import moment from "moment";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";

const PayrollSteps: React.FC = () => {
    const [open, setOpen] = React.useState(null);
    const [loading, setloading] = React.useState(false)
    const [stage, setStage] = React.useState('leave-attendance')
    const [reviewEmployees, setReviewEmployees] = React.useState(false)
    const parasm = useSelector(({ app }) => app?.params)
    let current_month = moment(parasm?.selectedMonth).format('MM-YYYY')
    const payRollData = useSelector(({ app }) => app?.cache[`payroll-${current_month}`]?.data);
    const lastUpdatedAt = moment(payRollData?.updatedAt).format('MMM MM, YYYY, (HH:mm A)')

    const dispatch = useDispatch()

    const onClickOpen = (title, key) => {
        if (key) {
            setStage(key)
            setOpen(title);
        }
    }


    const runPayroll = async () => {
        setloading(true)
        try {
            const resData = await dispatch(getData('/payroll-run/get-total-salary', { month: current_month }))
            if (resData.code == 200) {
                console.log("resDataresDataresData", resData)
                notification.success({
                    message: 'Successfully executed',
                    description: 'Payroll Executed successfully'
                })
            } else {
                notification.error({
                    message: 'Faild to executed',
                    description: 'Payroll faild to executed'
                })
            }
        } catch (error) {
            console.log("errorerror", error)
        } finally {
            setloading(false)
        }
    }


    const steps = [
        {
            title: "Leave, Attendance & Daily Wages",
            key: "leave-attendance",
            icon: <CalendarOutlined style={{ fontSize: 24, color: "#9b5de5" }} />,
            lastChange: lastUpdatedAt,
            user: payRollData?.updatedBy?.firstName,
        },
        {
            title: "New Joinees & Exits",
            key: "new-joinees-exits",
            icon: <UserOutlined style={{ fontSize: 24, color: "#00bbf9" }} />,
            lastChange: lastUpdatedAt,
            user: payRollData?.updatedBy?.firstName,
        },
        {
            title: "Bonus, Salary Revisions & Overtime",
            key: "bonus-salary-revisions-overtime",
            icon: <DollarOutlined style={{ fontSize: 24, color: "#00f5d4" }} />,
            lastChange: lastUpdatedAt,
            user: payRollData?.updatedBy?.firstName,
        },
        {
            title: "Reimbursement, Adhoc Payment, Deduction",
            icon: <FileOutlined style={{ fontSize: 24, color: "#f15bb5" }} />,
            lastChange: lastUpdatedAt,
            key: "reimbursement-adhoc-payment-deduction",
            user: payRollData?.updatedBy?.firstName,
        },
        {
            title: "Salaries on Hold & Arrears",
            icon: <ExceptionOutlined style={{ fontSize: 24, color: "#ffaa00" }} />,
            lastChange: lastUpdatedAt,
            user: payRollData?.updatedBy?.firstName,
            key: "salaries-on-hold-arrears",
        },
        {
            title: "Override (PT, ESI, TDS, LWF)",
            icon: <AuditOutlined style={{ fontSize: 24, color: "#5468ff" }} />,
            lastChange: lastUpdatedAt,
            user: payRollData?.updatedBy?.firstName,
            key: "override-pt-esi-tds-lwf",
        },
    ];

    return (
        <Card
            title={
                <Flex justify="space-between" style={{ width: '100%' }}>
                    <Typography.Title level={5}>Run Payroll</Typography.Title>
                    <div>
                        <Progress percentPosition={{ align: 'center', type: 'inner' }}
                            size={[200, 20]} percent={10}
                        />
                    </div>
                    <span>0 of 6 steps completed</span>
                </Flex>
            }
        >
            <ComponentModal key={stage} open={open} onClose={() => setOpen(false)} stage={stage} />
            <ReviewEmployees open={reviewEmployees} onClose={() => setReviewEmployees(false)} />
            <Row gutter={[16, 16]}>
                {steps.map((step, index) => (
                    <Col xs={24} sm={12} lg={8} key={index} onClick={() => onClickOpen(step?.title, step?.key)}>
                        <Card hoverable>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                {step.icon}
                                <div>
                                    <h4 style={{ margin: 0 }}>{step.title}</h4>
                                    <p style={{ margin: 0, fontSize: "12px", color: "#888" }}>
                                        {step?.user && `Last changes on ${step.lastChange}`}
                                    </p>
                                    {step.user && <p style={{ margin: 0, fontSize: "12px", color: "#888" }}>By {step.user}</p>}
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
            <div style={{ marginTop: "20px", display: "flex", justifyContent: "space-between" }}>
                <p style={{ color: "#888" }}>
                    {payRollData?.updatedBy?.firstName && `Last changes on ${lastUpdatedAt} by ${payRollData?.updatedBy?.firstName}`}
                </p>
                <div style={{ display: "flex", gap: "10px" }}>
                    <Button type="default">Preview Run Payroll</Button>
                    <Button type="default" onClick={() => setReviewEmployees(true)}>Review all employees</Button>
                    <Button type="primary" onClick={() => runPayroll()} loading={loading} >Finalize Payroll</Button>
                </div>
            </div>
        </Card>
    );
};

export default PayrollSteps;
